import { LuX } from 'react-icons/lu';

interface MobileToastCloseButtonProps {
    closeToast: (event: React.MouseEvent) => void;
}

export function MobileToastCloseButton({ closeToast }: MobileToastCloseButtonProps) {
    return (
        <button
            type='button'
            className='mobile-toast-close'
            onClick={closeToast}
            aria-label='Dismiss notification'>
            <LuX className='size-3.5' />
        </button>
    );
}
